/**
 * @file
 * Keeps a row of Lottie animations playing in step.
 *
 * The animations in a comparison are rarely the same length, so their own loop
 * attributes drift them apart after the first pass. This takes the loop off and
 * runs it here: play together, wait for the slowest, hold, restart together.
 *
 * The markup keeps autoplay and loop so the animations still run without this
 * script, just unsynchronised.
 */
(function (Drupal, once) {
  'use strict';

  var HOLD_MS = 2000;
  var POLL_MS = 120;
  var POLL_LIMIT = 250;

  function conduct(group) {
    var players = Array.prototype.slice.call(
      group.querySelectorAll('lottie-player')
    );

    if (!players.length) {
      return;
    }

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finished = 0;
    var ready = false;
    var running = false;
    var holdTimer = null;
    var pollTimer = null;
    var polls = 0;
    var visible = true;

    function allReady() {
      return players.every(function (player) {
        var animation = player.getLottie && player.getLottie();
        return !!(animation && animation.isLoaded);
      });
    }

    function startCycle() {
      running = true;
      finished = 0;
      players.forEach(function (player) {
        player.stop();
        player.play();
      });
    }

    function stopHold() {
      if (holdTimer) {
        window.clearTimeout(holdTimer);
        holdTimer = null;
      }
    }

    function onComplete() {
      finished += 1;

      if (finished < players.length) {
        return;
      }

      running = false;

      // Reduced motion gets one pass and keeps the finished frame.
      if (reduced) {
        return;
      }

      holdTimer = window.setTimeout(function () {
        holdTimer = null;
        if (visible) {
          startCycle();
        }
      }, HOLD_MS);
    }

    // Removing the loop is what makes the player emit 'complete' instead of
    // silently restarting.
    players.forEach(function (player) {
      player.loop = false;
      player.removeAttribute('loop');
      player.addEventListener('complete', onComplete);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;

            if (!visible) {
              stopHold();
              running = false;
              players.forEach(function (player) {
                player.pause();
              });
              return;
            }

            // Resuming mid-cycle would restore the drift, so start a fresh one.
            if (ready && !running && !holdTimer) {
              startCycle();
            }
          });
        },
        { threshold: 0.15 }
      ).observe(group);
    }

    // Polled rather than hung off the player's 'load' event: the player is
    // registered in the page head and often fires that before this deferred
    // script can listen, and a missed event would mean never starting.
    pollTimer = window.setInterval(function () {
      polls += 1;

      if (!allReady()) {
        if (polls >= POLL_LIMIT) {
          window.clearInterval(pollTimer);
          pollTimer = null;
        }
        return;
      }

      window.clearInterval(pollTimer);
      pollTimer = null;
      ready = true;

      if (visible) {
        startCycle();
      } else {
        players.forEach(function (player) {
          player.stop();
        });
      }
    }, POLL_MS);
  }

  Drupal.behaviors.campaignAnimation = {
    attach: function attach(context) {
      once('campaign-animation', '[data-campaign-animation]', context).forEach(
        conduct
      );
    },
  };
})(Drupal, once);
